module.exports = __webpack_public_path__ + "assets/img/de-46dba641.png";